import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { FaTimesCircle, FaUserCircle } from "react-icons/fa";
import moment from "moment";

import sightseeing from "../reducers/sightseeing";

import { API_URL } from "utilis/urls";

const Comment = ({ comment, thisActivity }) => {
  const dispatch = useDispatch();
  const userId = useSelector((store) => store.user.userId);
  const accessToken = useSelector((store) => store.user.accessToken);

  const onDelete = (id, storyId) => {
    const options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    };

    if (userId === comment.user._id) {
      fetch(API_URL(`stories/${storyId}/comments/${id}`), options)
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            dispatch(sightseeing.actions.deleteComment(data.response));
          } else {
            console.log("unsuccessful delete");
          }
        });
    }
  };

  return (
    <CommentContainer>
      {comment.user.avatar ? (
        <img
          src={`/assets/${comment.user.avatar}.png`}
          alt={comment.user.avatar}
          style={{ height: 35, width: 35, marginRight: 8 }}
        ></img>
      ) : (
        <FaUserCircle style={{ height: 35, width: 35, marginRight: 8 }} />
      )}
      <CommenterWrapper>
        <CommentText>
          <StyledUsername>{comment.user.username}</StyledUsername>
          <div style={{ display: "flex", alignItems: "center" }}>
            <StyledDate>{moment(comment.createdAt).fromNow()}</StyledDate>
            {userId === comment.user._id && (
              <FaTimesCircle
                onClick={() => onDelete(comment._id, thisActivity._id)}
                style={{ height: 15, width: 15, marginLeft: 10 }}
              />
            )}
          </div>
        </CommentText>
        <StyledParagraph>{comment.message}</StyledParagraph>
      </CommenterWrapper>
    </CommentContainer>
  );
};

export default Comment;

const CommentContainer = styled.div`
  padding: 15px 0 25px;
  border-bottom: 2px solid #36baa0;
  display: flex;
`;

const CommenterWrapper = styled.div`
  width: 100%;
  margin-bottom: 10px;
`;

const CommentText = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-top: 3px;
`;
const StyledDate = styled.p`
  margin: 0;
  font-style: italic;
  color: grey;
  font-size: 14px;
  font-weight: 600;
`;

const StyledUsername = styled.h5`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
`;

const StyledParagraph = styled.p`
  margin: 0;
  font-size: 16px;
  max-width: 300px;
`;
